import { type DrawerTypeValue, drawerType } from '../../../drawerTypes.ts';
import { useGetLalSegments } from '../../../hooks/useGetLalSegments.ts';
import { useSegments } from '../../../hooks/useSegments.ts';
import { useLookalikePagination } from '../components/SegmentsList/hooks/useLookalikePagination.ts';
import { useSegmentPagination } from '../components/SegmentsList/hooks/useSegmentPagination.ts';
import { useLookalikeDrawerActions } from './lookalike/useLookalikeDrawerActions.ts';
import { useLookalikeModal } from './lookalike/useLookalikeModal.ts';
import { useLookalikeSegmentsSelection } from './lookalike/useLookalikeSegmentsSelection.ts';
import { useDrawerActions } from './segments/useDrawerActions.ts';
import { useSegmentSelection } from './segments/useSegmentSelection.ts';
import type { LookalikeDrawerConfig, SegmentsDrawerConfig } from './types.ts';

export type DrawerConfig = SegmentsDrawerConfig | LookalikeDrawerConfig;

export function useGetDrawerConfig(currentDrawerType: 'segments'): SegmentsDrawerConfig;
export function useGetDrawerConfig(currentDrawerType: 'lookalike'): LookalikeDrawerConfig;
export function useGetDrawerConfig(currentDrawerType: DrawerTypeValue): DrawerConfig;
export function useGetDrawerConfig(currentDrawerType: DrawerTypeValue): DrawerConfig {
  switch (currentDrawerType) {
    case drawerType.SEGMENTS:
      return {
        type: drawerType.SEGMENTS,
        useDrawerActions,
        useSegmentSelection,
        useLookalikeModal,
        useSegmentDataFetch: useSegments,
        useSegmentPagination,
      };

    case drawerType.LOOKALIKE:
      return {
        type: drawerType.LOOKALIKE,
        useDrawerActions: useLookalikeDrawerActions,
        useSegmentSelection: useLookalikeSegmentsSelection,
        useSegmentDataFetch: useGetLalSegments,
        useLookalikeModal,
        useSegmentPagination: useLookalikePagination,
      };
  }
}
